export default __webpack_public_path__ + "static/collection-6-b5c994eb7f023591a214b770b019ec23.webp";